/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import path from 'path';
import { IBinding, IModuleBinder, IModuleBinderPartial } from './models';

/* eslint-disable @typescript-eslint/no-explicit-any */

export const initBindings = async (bindings: IBinding, isModuleEntryPointsEnabled: boolean) => {
    await Promise.all(
        Object.keys(bindings.modules).map(async moduleKey => {
            const originalBinder: IModuleBinderPartial = <IModuleBinderPartial>(<unknown>bindings.modules[moduleKey]);
            try {
                const binder: IModuleBinder = <IModuleBinder>{};
                const fetchComponent = isModuleEntryPointsEnabled ? originalBinder.c() : await originalBinder.c();
                binder.component = fetchComponent.default;
                binder.moduleDirectory = originalBinder.md;
                binder.dataActions = originalBinder.da;
                binder.packageName = originalBinder.p;
                binder.name = originalBinder.n;
                binder.definitionPath = path.join(originalBinder.md, `${originalBinder.n}.definition.json`);
                binder.parentDefinitionPath = originalBinder.pdp;
                binder.isNodeModule = originalBinder.iNM;
                binder.moduleNamespace = originalBinder.ns;
                binder.chunkName = `${originalBinder.ns}-${originalBinder.p}-${originalBinder.n}`;
                bindings.modules[moduleKey] = binder;
            } catch (e) {
                console.error(`failed to load module chunk :: ${moduleKey}`, e);
            }
        })
    );

    await Promise.all(
        Object.keys(bindings.views).map(async viewKey => {
            const viewComponent: any = bindings.views[viewKey];
            try {
                const fetchViewComponent = isModuleEntryPointsEnabled ? viewComponent.c() : await viewComponent.c();
                (<any>bindings.views[viewKey]).component = fetchViewComponent.default;
            } catch (e) {
                console.error(`failed to load view chunk :: ${viewKey}`, e);
            }
        })
    );

    await Promise.all(
        Object.keys(bindings.components).map(async componentKey => {
            const ecommerceComponent: any = bindings.components[componentKey];
            try {
                const fetchEComComponent = await ecommerceComponent.c();
                (<any>bindings.components[componentKey]).component = fetchEComComponent.default;
            } catch (e) {
                console.error(`failed to load component chunk :: ${componentKey}`, e);
            }
        })
    );
};
